// extracted by mini-css-extract-plugin
export default {"root":"cardTitle_root__QWinn","noMargin":"cardTitle_noMargin__mZrH4","ghost":"cardTitle_ghost__5ElXe","bold":"cardTitle_bold__6wE7K","big":"cardTitle_big__s+bIT"};